/*
 * lead-preventivo-tracker.js
 * Fotorecord — tracking richieste preventivo (Google Ads + GA4).
 *
 * Su ogni invio di un form di richiesta preventivo spara:
 *   1) Conversione Google Ads `lead_preventivo` (AW-10826457907/z17UCIfqkbQcELPGuqoo)
 *      → ottimizzazione campagne (Smart Bidding).
 *   2) Evento GA4 `generate_lead` (G-BHFR37GWJZ)
 *      → funnel, report e pubblici in GA4.
 *
 * Fonti coperte:
 *   - /pages/contatti-ed-assistenza (form Shopify #ContactForm, redirect ?contact_posted=true)
 *   - Configuratore aste su misura      → fotorecordLeadConversion('aste', valore)
 *   - Configuratore montature a giorno   → fotorecordLeadConversion('montature', valore)
 *   - Configuratore pannelli solo vetro  → fotorecordLeadConversion('pannelli', valore)
 *   - Configuratore opere d'autore       → fotorecordLeadConversion('opere_autore', valore)
 *   - Quiz cornici                       → fotorecordLeadConversion('quiz_aste', valore)
 *
 * API:  window.fotorecordLeadConversion(source [, value])
 *   - source: stringa fonte (per attribuzione: GA4 lead_source + transaction_id)
 *   - value : valore stimato ordine (numero o stringa "€ 30,97"). Se assente,
 *             il tracker prova a leggerlo dal prezzo a video (PRICE_SELECTORS),
 *             altrimenti usa DEFAULT_VALUE.
 *
 * Anti double-fire: sessionStorage "fr_lead_fired" (una volta per sessione).
 * gtag è caricato dall'app Shopify "Google & YouTube" (vedi theme.liquid).
 */
(function () {
  'use strict';

  var ADS_TARGET = 'AW-10826457907/z17UCIfqkbQcELPGuqoo';
  var GA4_TARGET = 'G-BHFR37GWJZ';
  var DEFAULT_VALUE = 30.0;
  var CURRENCY = 'EUR';
  var SESSION_FLAG = 'fr_lead_fired';
  /* prezzo a video usato come fallback se il chiamante non passa un valore */
  var PRICE_SELECTORS = ['#qasm-pf-num', '.casm-price-amount', '#qasm-price-val'];

  /* "€ 1.234,56" | "30,97" | 30.97  →  numero (o null) */
  function parsePrice(raw) {
    if (raw == null) return null;
    if (typeof raw === 'number') return (isFinite(raw) && raw > 0) ? raw : null;
    var s = String(raw)
      .replace(/[^0-9.,]/g, '')      // tieni solo cifre, punto, virgola
      .replace(/\.(?=\d{3}(\D|$))/g, '') // togli punto separatore migliaia
      .replace(',', '.');             // virgola decimale → punto
    var n = parseFloat(s);
    return (isFinite(n) && n > 0) ? n : null;
  }

  function resolveValue(value) {
    var v = parsePrice(value);
    if (v != null) return v;
    for (var i = 0; i < PRICE_SELECTORS.length; i++) {
      var el = document.querySelector(PRICE_SELECTORS[i]);
      if (el) { var p = parsePrice(el.textContent); if (p != null) return p; }
    }
    return DEFAULT_VALUE;
  }

  function fire(source, value, attempt) {
    attempt = attempt || 0;
    try {
      if (sessionStorage.getItem(SESSION_FLAG) === '1') {
        console.log('[lead_preventivo] gia sparata in questa sessione — skip (source=' + source + ')');
        return;
      }
    } catch (_) { /* sessionStorage non disponibile, procedi */ }

    // gtag puo essere ancora in caricamento (script async app Google & YouTube). Retry ~5s.
    if (typeof window.gtag !== 'function') {
      if (attempt < 25) {
        setTimeout(function () { fire(source, value, attempt + 1); }, 200);
        return;
      }
      console.warn('[lead_preventivo] gtag non disponibile dopo 5s — non sparata (source=' + source + ')');
      return;
    }

    var val  = resolveValue(value);
    var txid = 'lead_' + source + '_' + Date.now();

    // 1) Conversione Google Ads
    window.gtag('event', 'conversion', {
      send_to: ADS_TARGET,
      value: val,
      currency: CURRENCY,
      transaction_id: txid,
      event_callback: function () {
        console.log('[lead_preventivo] Ads conversion fired (source=' + source + ', value=' + val + ')');
      },
    });

    // 2) Evento GA4 generate_lead
    window.gtag('event', 'generate_lead', {
      send_to: GA4_TARGET,
      value: val,
      currency: CURRENCY,
      lead_source: source,
      transaction_id: txid,
    });

    try { sessionStorage.setItem(SESSION_FLAG, '1'); } catch (_) {}
  }

  // Esposto globale per quiz + configuratori
  window.fotorecordLeadConversion = fire;

  // Auto-fire sul redirect di successo del form Shopify contact (qualsiasi /pages/<x>)
  document.addEventListener('DOMContentLoaded', function () {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('contact_posted') === 'true') {
        fire('contatti');
      }
    } catch (_) { /* URLSearchParams non supportato su browser molto vecchi */ }
  });
})();
